import { render, staticRenderFns } from "./robotizationlabel.vue?vue&type=template&id=22513472&scoped=true&"
import script from "./robotizationlabel.vue?vue&type=script&lang=js&"
export * from "./robotizationlabel.vue?vue&type=script&lang=js&"
import style0 from "./robotizationlabel.vue?vue&type=style&index=0&id=22513472&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22513472",
  null
  
)

export default component.exports